// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import L from 'leaflet';

myw.DirectoryTileLayer = L.TileLayer.extend({
    /**
     * @class  Define a myWorld specific map tile layer for tiles stored in the old directory structure.<br/>
     * Extends {@link http://leafletjs.com/reference.html#tilelayer|L.TileLayer}
     * @constructs
     * @param  {string} url     The base url for the obtaining tiles
     * @param  {object} options Options as specified for {@link http://leafletjs.com/reference.html#tilelayer|L.TileLayer}
     */
    initialize(url, options) {
        // Set the baseline URL
        this._url = url;

        L.Util.setOptions(this, options);
    },

    /**
     * This method subclass ensures that a handle is kept to the map.
     */
    onAdd(map) {
        // Call the super implementation
        L.TileLayer.prototype.onAdd.call(this, map);

        // Keep the map.
        this._map = map;
    },

    /**
     * myWorld uses a non-standard URL path for its types.  This method is builds the
     * appropriate URL given a tile point.
     */
    getTileUrl(tile_point) {
        // Get the zoom level and x value from the map.
        const zoom = this._map.getZoom();
        const x = tile_point.x % (1 << zoom);

        return `${this._url + zoom}/${x.toString().substring(0, 2)}/${x}/${zoom}_${x}_${
            tile_point.y
        }.png`;
    }
});

export default myw.DirectoryTileLayer;
